import { useHighlightMessages } from 'components/OfferList/OfferListTiles/constants'
import { useDirectSearchPrices } from 'hooks/Search/useSearchPrices'
import useBestPriceBundleAndSavePackage from 'hooks/useBestPriceBundleAndSavePackage'
import { EmptyObject } from 'lib/object/objectUtils'
import { useMemo } from 'react'
import SearchTileHighlightBanner from '../shared/SearchTileHighlightBanner'

interface Props {
  offer: App.BundleOffer
  offerMetaData: App.BundleOfferListMetaData
  filters?: App.OfferListFilters
}

function HotelBundleSearchTileHighlightBanner({ offer, offerMetaData, filters }: Props) {
  const { highlightMessageAvailableForDates, highlightMessageUnavailableForDates } = useHighlightMessages()
  const directSearchPrices = useDirectSearchPrices({ filters: filters ?? EmptyObject, offerId: offer.id })
  const {
    bestPricePackage,
    bestPriceError,
    fetching,
    available,
    useBestPrice,
  } = useBestPriceBundleAndSavePackage(offer, offerMetaData.bundledOfferId, filters, directSearchPrices, offerMetaData)

  const description = useMemo(() => {
    const isSearchAvailable = !!offerMetaData.available
    if (offer.isSoldOut || !bestPricePackage) {
      return highlightMessageUnavailableForDates(offer.saleUnit)
    }
    if (useBestPrice) {
    // If direct search prices are available, we can show the expanded tile (using search pricing)
      if (directSearchPrices && isSearchAvailable) {
        return highlightMessageAvailableForDates
      } else if (directSearchPrices && !isSearchAvailable) {
        return highlightMessageUnavailableForDates(offer.saleUnit)
      } else if (fetching) {
        return undefined
      } else if (available || bestPriceError) {
        return highlightMessageAvailableForDates
      } else {
        return highlightMessageUnavailableForDates(offer.saleUnit)
      }
    } else {
      return highlightMessageAvailableForDates
    }
  }, [available, bestPriceError, bestPricePackage, directSearchPrices, fetching, highlightMessageAvailableForDates, highlightMessageUnavailableForDates, offer, offerMetaData, useBestPrice])

  if (!description) return null

  return <SearchTileHighlightBanner description={description} />
}

export default HotelBundleSearchTileHighlightBanner
